import { addDays } from '@if/core/date'
import { formatIsoDate } from '@if/core/utils'

export const getStartDate = () => formatIsoDate(addDays(new Date(), -90))

export const getEndDate = () => formatIsoDate(addDays(new Date(), 1))
